module.exports = __webpack_public_path__ + "salesforce.svg?b5783451c067c719e19e3329d6b139d9";